/**
 * Backend API origin for Admin. CRA inlines env at build time; this corrects
 * stale production builds that still point at legacy hosts.
 */
const DEFAULT = "https://api.beentara.com";

function normalize(u) {
  return String(u || "")
    .trim()
    .replace(/\/+$/, "");
}

const raw = normalize(process.env.REACT_APP_LINK);

export const API_BASE_URL =
  !raw || raw.includes("100billionfinance.in") ? DEFAULT : raw;
